import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
// import admindata from '../../components/admindata'
import { apiRequest } from '../../store/allApi'
 
export default function UpiList() {

    const [Admin, setAdmin] = useState([])
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

      const allAdmins = async() => {
        const access_token = localStorage.getItem("token")
        const headers = {
          Authorization: `Bearer ${access_token}`
        }
          try {
                  const res = await apiRequest(`admin-banks`,"GET", null,headers)
                 if (res.data) {
                  setAdmin(res.data)
                 }
                    } catch (e) {
                      console.log(e);
                    }
                    finally {
                    }
        
      }

    useEffect(() => {
       allAdmins()
    }, [])

    if (Admin === undefined) {
        return null
    }

    const dateFormat = (e) => {
        const date = new Date(e);
        const newDate = date.toLocaleString('en-US', { 
            month: 'long', 
            day: 'numeric', 
            hour: 'numeric', 
            minute: 'numeric', 
            hour12: true,
            timeZone: 'UTC'  // 👈 Important!
        });
        return newDate;
    };
    
    

    const id = localStorage.getItem("id")
    const userData = localStorage.getItem("userData")

    return (
        <>

            {/* <h4 className='text-uppercase font-weight-bold my-3'>all Admin list</h4> */}
            <div className="row  ">
                <div className="col-12 grid-margin">
                    <div className="card ">
                        <div className="card-body text-light"  >
                            <h4 className="card-title text-dark">Upi List</h4>
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th> ID</th>
                                            <th> Action By</th>
                                            <th> Type </th>
                                            <th> Qr </th>
                                            <th>Upi Id</th>
                                            <th>Account </th>
                                            <th>Ifsc </th>
                                            <th>Time </th>
                                        </tr>
                                    </thead>
                                    {Admin?.map((admin, key) => (
                                        <tbody key={admin._id} >
                                            <tr>
                                                <td>{key + 1}</td>
                                                <td>{admin?.actionBy?._id}</td>
                                                <td>
                                                    <span className="pl-2">{admin?.actionBy?.Name}</span>
                                                </td>
                                                <td>
                                                  {
                                                    admin.type === "PayNowTwo" ? "QR-UPI" : admin.type === "PayNowOne" ? "UPI" :"Account"
                                                  }  
                                                    </td>
                                                <td>
                                                <a href={baseUrl + `/${admin?.qrcode}`} target='_blank'>
                                                <img
                                className='img'
                                src={baseUrl + `/${admin?.qrcode}`}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = '/no-image.png';
                                }}
                                alt='kyc'
                                style={{
                                  borderRadius: '5px',
                                  width: '4rem',
                                  height: '4rem'
                                }}
                              />
                              </a>
                                                </td>
                                                <td>
                                                    {admin?.upi_id}
                                                </td>
                                                <td>
                                                    {admin?.account_number}
                                                </td>
                                                <td>
                                                    {admin?.ifsc_code}
                                                </td>
                                                <td>
                                                {dateFormat(admin?.createdAt).split(',')[0]}
                                                </td>
                                            </tr>
                                        </tbody>
                                    ))}
                                </table>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </>
    )
}
